import React from 'react';
import PreLoginPage from '../../views/core/PreLoginPage';
import '../../css/LoginForm.css';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import { FormWithConstraints, FieldFeedback } from 'react-form-with-constraints';
import { FieldFeedbacks, FormGroup, FormControlLabel, FormControlInput } from 'react-form-with-constraints-bootstrap4';
import HmAjax from '../../util/HmAjax';
import NativeAjax from '../../util/NativeAjax';
import UserStore from '../../util/UserStore';
import $ from 'jquery';

var fpServerResponses = {
	200: 'An email has been sent to <span class="hm-blue"><email></span> with the link to reset the password. Please check your Inbox and Spam/Junk folders.',
	403: 'You are not allowed to reset your password. Please write to <a href="mailto:support@heymath.com">support@heymath.com</a>',
	600: 'Invalid User ID / Email / Mobile no.', // also for 400, 401
	0: 'An unexpected error occurred. Please try again after sometime or write to <a href="mailto:support@heymath.com">support@heymath.com</a>'
  };

class MobileSignUp extends PreLoginPage {

	constructor(props) {
		super(props);

		this.state = {	
			username_newacc: '',
			password_newacc: '',
			confirmpassword_newacc: '',
			singupType:"userid",
			loginType:this.props.loginType || "mobile",
			userInput:this.props.userInput || "",
			otp_newacc: '',				
			submitButtonDisabled: false,
			serverMessage: "",
			emailfeedbackmsg: "",
			source:"plp",
			isOTPSend:false,
			isVerified:false,
			OTPDisabled:"hiddenOTP",
			verifyDisabled:"disabled",
			emailDisabled:false,
			phoneDisabled:false,
			verifyText:this.rb("mobile.submit"),
			sendOTPText:this.rb("register.sendOTP"),
			passcodeDisabled:"disabled",
			selectedRole:"STU",
			resetSuccess:false,
			passwordType:"password",
			confirmPasswordType:"password"
		};
		
		this.classesTeaching = null;
		//this.selectedRole = null;
		this.userReferal = null;

		this.navigationKey="PLP_Navigation";

		this.handleChange = this.handleChange.bind(this);		
		this.enterOTPChange = this.enterOTPChange.bind(this);
		this.handleSubmit = this.handleSubmit.bind(this);
		this.userIdChange = this.userIdChange.bind(this);
		
		this.sendOTP = this.sendOTP.bind(this);
		this.verifyOTP = this.verifyOTP.bind(this);
		this.getOTPField = this.getOTPField.bind(this);
		this.handleKeyUp = this.handleKeyUp.bind(this);

		this.myTrackerInstance = this.getTracker();
		
		this.gaFrom = this.props.gaFrom;
		//console.log("this.gaFrom:::::::::::",this.gaFrom);
		if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
			this.gaFrom = this.gaFrom+" Home - Join";
		}else{
			this.gaFrom = "Users who have independently registered - Sign Up";
		}
		//console.log("this.gaFrom2222:::::::::::",this.gaFrom);
	}

	  componentWillReceiveProps(nextProps) {
	  	var me = this;

	  	this.gaFrom = nextProps.gaFrom;
	  	//console.log("this.gaFrom:::::::::::",this.gaFrom);
	  	if(this.gaFrom == "Top" || this.gaFrom == "Bottom"){
	  		this.gaFrom = this.gaFrom+" Home - Join";
	  	}else{
	  		this.gaFrom = "Users who have independently registered - Sign Up";
	  	}

	  	//console.log("this.gaFrom:::::::::::",this.gaFrom);
	  	//console.log('componentWillReceiveProps', nextProps);    
	  	this.setState({	
	  		loginType:nextProps.loginType || "mobile",
	  		userInput:nextProps.userInput || "",
	  		otp_newacc: '',				
	  		submitButtonDisabled: false,
	  		serverMessage: "",
	  		emailfeedbackmsg: "",
	  		source:"plp",
	  		isOTPSend:false,
	  		isVerified:false,
	  		OTPDisabled:"hiddenOTP",
	  		verifyDisabled:"disabled",
	  		emailDisabled:false,
	  		phoneDisabled:false,
	  		verifyText:this.rb("mobile.submit"),
	  		sendOTPText:this.rb("register.sendOTP"),
	  		passcodeDisabled:"disabled"
	  	});
		let callFrom = this.props.callFrom;
          if(callFrom === "signup"){
			setTimeout(function(){
                me.reinitiate();
            },500)
		}

	  }
	  componentDidMount(){
	  	var me = this;
	  	this.sessionCheck();
	  		
		let callFrom = this.props.callFrom;
		if(callFrom === "signup"){
			setTimeout(function(){
				me.reinitiate();
			},200);
		}
	  } 

	  reinitiate(){		
	  	//console.log("reinitiate gaFrom:::::::::::",this.gaFrom);
	  	if(this.state.userInput != ""){
	  		this.form.validateFields();
	  		this.setState({ submitButtonDisabled: !this.form.isValid() });
	  		if(this.form.isValid()){
	  			this.setState({ OTPDisabled: ""});			
	  			$(".OTPButton").trigger("click");
	  		}
	  	}

	  	$("#loginRoot .userInput").focus();
	  }

	  handleChange(e) {
	  	const target = e.currentTarget;	
		//console.log("target=",target);
		this.form.validateFields(target);

		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled: !this.form.isValid()
		});
	}
	userIdChange(e){
		const target = e.currentTarget;
		this.form.validateFields(target);
		
		var phoneRegx = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s\./0-9]*$/g;
		
		if(phoneRegx.test(target.value)){
			this.setState({loginType:"mobile",loginMaxLength:10,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
			if(target.value.length >= 10){				
				this.setState({ OTPDisabled: "",passcodeDisabled:""});
			}
		}else{
			this.setState({loginType:"email",loginMaxLength:254,OTPDisabled: "hiddenOTP",isOTPSend:false,isVerified:false,passcodeDisabled:"disabled"});
			//this.setState({ [target.name]: "hidden",isOTPSend:false,isVerified:false,password_newacc:""});
			if(target.value.match(/^[a-zA-Z0-9_+\-%]+[a-zA-Z0-9_.+\-%]+[a-zA-Z0-9_+\-%]+@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/)){
				this.setState({ OTPDisabled: "",passcodeDisabled:""});
			}
		}
		
		this.setState({
			[target.name]: target.value,
			serverMessage:"",
			submitButtonDisabled:true
		});
		
	}
	
	enterOTPChange(e){
		if(this.otp.value.length > 0){
			this.setState({ verifyDisabled: ""});
		}else{
			this.setState({ verifyDisabled: "disabled"});
		}
		this.handleChange(e);
	}
	
	hmNav = function(userObj){		
		if(userObj && userObj.userRole && userObj.userRole.role && userObj.userRole.role.toUpperCase() === "TCHR"){
			window.top.location.href = "/teachers";
		}else{
			window.top.location.href = this.props.navigateURL;
		}	

		//this.props.myProps.history.push(this.props.navigateURL);
		
	}

updateUserType(commonCallback){
	var me=this;
	var callBackSuccess = function(response){
		if(response!== null){
			//console.warn("user type",response)
			me.getUser().store(response);
		}

		if(typeof commonCallback === "function"){
			commonCallback.apply(this);
		}
	}

	var callBackFailure = function(response){
		//console.warn("failure ",response);

		if(typeof commonCallback === "function"){
			commonCallback.apply(this);
		}
	}

	super.updateUserType(callBackSuccess,callBackFailure)
}


submitForm = function(){		
	var verificationtype = this.state.loginType;
	var formData = {
		"userName" : this.state.username_newacc,
		"loginId" : this.state.userInput,
		"userRole" : {
			"role" : this.state.selectedRole || "STU",
			"level": "1"
		},				
		"token" : this.state.otp_newacc,
		"countryCode" : "IN",
		"password" : this.state.password_newacc,
		"verificationType" : verificationtype,
		"regnProvider" : "heymath",
				"schoolName":this.state.schoolname_newacc, //Shyam
				"location":this.state.address_newacc,
				"classesTeaching":this.classesTeaching,
				"userOrigin":this.userReferal
			}
			if(this.state.loginType == "mobile"){
				formData["phone"] = this.state.userInput;
			}else{
				formData["email"] = this.state.userInput;
			}

			var me =this;

			me.setState({submitButtonDisabled: true});

			var callBackSuccess = function(response){
				if(response !== null){
					if(response.status.toLowerCase() == "success"){	
						new UserStore().store(response.user);

					//me.props.successRegisterMsg(me.rb("register.success.msg"));
					
					try{
						me.doLumosLogout();
					}catch(e){}
					
					me.trackMe(true,"set_password");
					if(window.remedialAllowFilter){
						BrowserStorageUtil.storeItem("remedial", true);
					}

					let afterUpdate = function(){
						me.hmNav(response.user);
					};
					me.updateUserType(afterUpdate);
					
				}else{
					
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",submitButtonDisabled:false});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",submitButtonDisabled:false});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",submitButtonDisabled:false});
					}else if(response.status == "empty_inputs"){
						me.setState({serverMessage:"Please enter all the fields",submitButtonDisabled:false});
					}else if(response.status == "token_not_verified"){
						me.setState({serverMessage:"Passcode Verification is required",submitButtonDisabled:false});
					}else if(response.status == "provider_forbidden"){
						me.setState({serverMessage:"Already registered with Gmail ID. Please click continue with Google",submitButtonDisabled:false});
					}
					else{
						me.setState({serverMessage:response.status,submitButtonDisabled:false});
					}
					me.trackMe(false,"set_password");
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_REGISTER");
			me.setState({submitButtonDisabled: false});
			me.showAlert("","Error in CREATE_REGISTER");
			me.trackMe(false,"set_password");
		}

		new HmAjax(this.getUrlFor("CREATE_REGISTER"),formData).post(callBackSuccess,callBackFailure);
		new UserStore().clearOldUser();
	}

	trackMe(result,source){			
		
	}

	handleSubmit(e) {
		e.preventDefault();

		this.form.validateFields();

		this.setState({ submitButtonDisabled: !this.form.isValid() });

		if (this.form.isValid()) {   

			if(this.state.isOTPSend && this.state.isVerified){
				this.submitForm();    
			}
		}
	}
	
	sendOTP(){
		if(this.state.OTPDisabled == "hiddenOTP"){
			this.form.validateFields();
			return;
		}
		
		var me =this;
		var otpServerMsg = "";
		
		if(this.state.loginType == "mobile"){
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to mobile";
			}else{
				otpServerMsg = "OTP is sent to your mobile";
			}
		}else{
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to your email";
			}else{
				otpServerMsg = "OTP is sent to your email";
			}
		}
		
		me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});

		var formData = {
			"contactId":this.state.userInput,				
			"contactType":this.state.loginType
		}		

		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",passcodeDisabled:""});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});
					}else{
						me.setState({emailfeedbackmsg:otpServerMsg,passcodeDisabled:""});
					}
				}
				
				if(response.status == "success"){
					me.setState({isOTPSend:true,passcodeDisabled:"disabled"});
					me.trackMe(true,"send_otp");
				}else{
					me.trackMe(false,"send_otp");
				}

			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_SENDVERIFICATION_TOKEN");	
			me.setState({passcodeDisabled:""});
			me.trackMe(false,"send_otp");
		}

		new HmAjax(this.getUrlFor("CREATE_SENDVERIFICATION_TOKEN"),formData).post(callBackSuccess,callBackFailure);
	}

	sendOTPForPWDReset = () => {		
		// if(this.state.OTPDisabled == "hiddenOTP"){
		// 	this.form.validateFields();
		// 	return;
		// }
		
		var me =this;
		var otpServerMsg = "";
		
		if(this.state.loginType == "mobile"){
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to mobile";
			}else{
				otpServerMsg = "OTP is sent to your mobile";
			}
		}else{
			if(me.state.isOTPSend){
				otpServerMsg = "OTP is sent again to your email";
			}else{
				otpServerMsg = "OTP is sent to your email";
			}
		}
		
		me.setState({serverMessage:"",emailfeedbackmsg:"",isOTPSend:false,isVerified:false,verifyDisabled:"disabled",otp_newacc:"",passcodeDisabled:"disabled"});
				
		var formData = {
				"userId":this.state.userInput,				
				"contactType":this.state.loginType
		}		

		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",passcodeDisabled:""});
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",passcodeDisabled:""});
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",passcodeDisabled:""});
					}else if(response.status == "INVALID_EMAIL"){
						me.setState({serverMessage: fpServerResponses[600],passcodeDisabled:""});
					}else if(response.status == "INVALID_USERID"){
						me.setState({serverMessage: fpServerResponses[600],passcodeDisabled:""});
					}else if(response.status == "PROVIDER_FORBIDDEN"){
						me.setState({serverMessage: me.rb("google.errmsg.pwd"),passcodeDisabled:""});
					}
					else{
						me.setState({emailfeedbackmsg:otpServerMsg});
					}					
				}
				
				if(response.status.toLowerCase() == "success"){
					me.setState({isOTPSend:true,passcodeDisabled:"disabled"});
					me.trackMe(true,"send_otp");
				}else{
					me.trackMe(false,"send_otp");
				}
						
			}

			console.log("response : ", response);
		}

		var PLPcallBackFailure = function(response){
			console.log("Error in FORGOT_PWD");
			me.setState({passcodeDisabled:""});
			me.trackMe(false,"send_otp");
		}

		var callBackFailure = function(response){
			console.log("Error in FORGOT_PWD");
			//me.setState({passcodeDisabled:""});
			//me.trackMe(false,"send_otp");
			new NativeAjax(me.getUrlFor("PLP_COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, PLPcallBackFailure);
		}
		

		//new HmAjax(this.getUrlFor("FORGOT_PWD"),formData).post(callBackSuccess,callBackFailure);
		new NativeAjax(this.getUrlFor("COMMON_FORGOT_PWD"),formData).enableCORS().post(callBackSuccess, callBackFailure);
	}

	verifyOTP(){
		var me =this;
		me.setState({serverMessage:""});
		var verificationtype = this.state.loginType;
		var formData = {
			"verificationId":this.state.userInput
		}
		this.setState({verifyDisabled:"disabled"});
		var callBackSuccess = function(response){
			if(response !== null){
				if(response.status){
					if(response.status == "user_exists"){
						me.setState({serverMessage:"User already exists",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "no_such_token"){
						me.setState({serverMessage:"The OTP entered is incorrect",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else if(response.status == "error"){
						me.setState({serverMessage:"Internal error occured",verifyDisabled: ""});
						me.trackMe(false,"verify_otp");
					}else{
						me.setState({isVerified:true,verifyDisabled: ""});
                        me.trackMe(true,"verify_otp");
                        // if(typeof me.props.callBackParent === "function"){
                        //     me.props.callBackParent();
                        // }
					}
				}
			}

			console.log("response : ", response);
		}

		var callBackFailure = function(response){
			console.log("Error in CREATE_SENDVERIFICATION_TOKEN");	
			me.setState({verifyDisabled:""});
			me.trackMe(false,"verify_otp");
		}

		new HmAjax(this.getUrlFor("CREATE_VERIFY_EMAIL")+verificationtype+"/"+this.state.otp_newacc,formData).post(callBackSuccess,callBackFailure);
	}
	getOTPField(){
		if(this.state.isOTPSend){
			let plp_userinput = this.props.userInput;

			return(
				<FormGroup for="otp_newacc">
				<FormControlInput type="number" className="otp_newacc" name="otp_newacc" placeholder=""	
				innerRef={otp => this.otp = otp}
				onKeyUp={this.handleKeyUp}
				value={this.state.otp_newacc} onChange={this.enterOTPChange}
				required minLength={1} maxLength={6} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="3"/>
				<FieldFeedbacks for="otp_newacc">
				<FieldFeedback when="valueMissing">{this.rb("register.enterOTP")}</FieldFeedback>
				<FieldFeedback when="*" />
				</FieldFeedbacks>
				</FormGroup>
				);
		}
	}

	revealPasswordFn = () => {
		let passwordType = (this.state.passwordType ==="password") ?  "text" : "password";
        this.setState({passwordType:passwordType});
	}
	
	revealConformPasswordFn = () => {
        let confirmPasswordType = (this.state.confirmPasswordType ==="password") ?  "text" : "password";
        this.setState({confirmPasswordType:confirmPasswordType});
    }


getStep2StudentsForm(){
	let passwordIcon = this.state.passwordType === "password" ? 'img/remedialMobile/icons/icons_invisible.png' : 'img/remedialMobile/icons/icons_visible.png';
	let confirmpasswordIcon = this.state.confirmPasswordType === "password" ? 'img/remedialMobile/icons/icons_invisible.png' : 'img/remedialMobile/icons/icons_visible.png';
	return(
		<div>
		<FormGroup for="username_newacc" className="signupForm">
        <span className="inputLabel">{this.rb("signup.name")}</span>
		<div className="user-icon"><img src={'img/remedialMobile/icons/icons_user.png'}></img></div>
		<FormControlInput type="username_newacc" className="username_newacc" name="username_newacc" placeholder="Full Name"
		value={this.state.username_newacc} onChange={this.handleChange}
		required minLength={1} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="1"/>
		<FieldFeedbacks for="username_newacc">
		<FieldFeedback when="valueMissing">{this.rb("billing.namerequired")}</FieldFeedback>					 
		<FieldFeedback when="*" />
		</FieldFeedbacks>
		</FormGroup>
		<FormGroup for="password_newacc" className="signupForm">
        <span className="inputLabel">{this.rb("signup.newpwd")}</span>
		<div className="pwd-icon" onClick={this.revealPasswordFn}><img src={passwordIcon}></img></div>
		<FormControlInput type={this.state.passwordType} className="password_newacc" name="password_newacc" placeholder="New Password"						
		innerRef={password => this.password = password}
		value={this.state.password_newacc} onChange={this.handleChange}
		required minLength={6} maxLength={50}  autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="4" />
		
		<FieldFeedbacks for="password_newacc">
		<FieldFeedback when="valueMissing">{this.rb("login.pwdrequired")}</FieldFeedback>
		<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
		</FieldFeedbacks>
		</FormGroup>

		<FormGroup for="confirmpassword" className="signupForm">
        <span className="inputLabel">{this.rb("signup.conpwd")}</span>
		<div className="confirmpwd-icon" onClick={this.revealConformPasswordFn}><img src={confirmpasswordIcon}></img></div>
		<FormControlInput type={this.state.confirmPasswordType} className="confirmpassword_newacc" name="confirmpassword_newacc" placeholder="Confirm Password"
		innerRef={confirmpassword => this.confirmpassword = confirmpassword}
		value={this.state.confirmpassword_newacc} onChange={this.handleChange}				
		required minLength={6} maxLength={50} autoCapitalize="none" autoComplete="off" autoCorrect="off" spellCheck="false" tabIndex="5" />
		<FieldFeedbacks for="confirmpassword_newacc">
		<FieldFeedback when="valueMissing">{this.rb("rpwd.confirmpwdrequired")}</FieldFeedback>
		<FieldFeedback when={value => (value.length<6)}>{this.rb("validate.pwd.minimum",[6])}</FieldFeedback>
		<FieldFeedback when={value => value !== this.password.value}>{this.rb("rpwd.doesnotmatch")}</FieldFeedback>
		</FieldFeedbacks>					
		</FormGroup>

		<div className="clear clearfix"></div>

		<div className="server-messages pt-20">{this.state.serverMessage}</div>
		</div>
		);

}


setPassword(){
	if(this.state.isVerified){
		return this.getStep2StudentsForm();
	}		
}

bindLoginLink = () => {
	
	this.setState({resetSuccess:true});
}


handleKeyUp(event) {
	if (event.key === 'Enter' && this.form.isValid()) {	    	
		if(!this.state.isVerified){
			if(this.state.isOTPSend && this.state.verifyDisabled != "disabled"){
				$(".verifyButton").trigger("click");
			}else if(this.state.passcodeDisabled != "disabled"){
				this.setState({ OTPDisabled: ""});
				$(".OTPButton").trigger("click");				
			}
		}

	}
}


    getStarMobileNo = (str) => {
		if(str.length === 10){
			return str.replace(str.substring(3, 8), "*****")
		}
	}
    
    backFn = () => {
        if(typeof this.props.backFn === "function"){
            this.props.backFn()
        }
	}
	
	getTextForOTP = () => {
		let callFrom = this.props.callFrom;
		if(callFrom === "forgotPWD" && this.state.resetSuccess){
			return "Congrats, You have successfully reset your password"
		}else if(callFrom === "forgotPWD"){
			return "Reset Password here"
		}else{
			return "Looks like you are new here"
		}
	}

    mobileUIOTP = () => {
        let loginType = this.props.loginType;
        let from = this.props.from;
        let plp_userinput = this.props.userInput;
		let me=this;
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
		//console.log("submitbtnAddCls ",this.state.submitButtonDisabled);
		let callFrom  = this.props.callFrom;
		if(!this.state.isVerified && callFrom === "signup"){
            return(
                <div className="row otpMob">
                            <div className="col-sm-12 nopadding mob-banner">
                            <div className="backbtn" onClick={me.backFn}><img src={'img/remedialMobile/icons/arrow.png'}></img></div>
			<h1 className="otp-title">{this.getTextForOTP()}</h1>
                            </div>
            
                            <div id="otpMobile" className="remedialLogin col-sm-12">
            
                                <div className="container">
            
                                            <div className="row">
                                                <div className="col-md-12 mx-auto nopadding">
                                                    <div className="rounded-0">
                <span className="inputLabel">Enter the OTP sent to {this.getStarMobileNo(this.state.userInput)}</span>
                                                        <div className="text-center ">
                                                           
                                                            <FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
                                                                onSubmit={this.handleSubmit} noValidate>
                                                                {this.getOTPField()}	
                                                                 
            
                                                                <div className="server-messges">{me.state.serverMessage}</div>
            
                                                                {
                                                                    (()=>{
                                                                        if(this.state.isOTPSend && !this.state.isVerified){
                                                                            return (
                                                                                <button data-ga={"Home - " + me.gaFrom + me.gasignin + "  - Sign In"} disabled={me.state.submitButtonDisabled} className={"submitButton verifyButton"+submitbtnAddCls+" "+this.state.verifyDisabled} onClick={this.verifyOTP}>{this.rb("signup.btn")}</button>
                                                                            );
                                                                        }
                                                                    })()
                                                                }
                                                                
                                                                <div data-ga={"Home - " + this.gaFrom + this.gasignin + " - Forgot Password"} className="ufd-resendotp OTPButton" onClick={this.sendOTP}>
                                                                {this.rb("signup.resend.otp")}
                                                            </div>
                                                            </FormWithConstraints>
                                                        </div>
                                                    </div>
                                                </div>
            
            
                                            </div>
            
                                        </div>
                                    </div>
                                </div>
                        
                )
        }
	}

	checkForDisabled(){
		return true;
	}

    getPasswordUI = () => {
        //console.log("getPasswordUI ",this.state.isVerified);
        let me=this;
		let submitbtnAddCls = this.state.submitButtonDisabled ? " grey" : " teal";
        //console.log("submitbtnAddCls ",this.state.submitButtonDisabled);
        let callFrom  = this.props.callFrom;
        if(this.state.isVerified &&  callFrom === "signup"){
            return(
                <div className="row otpMob">
                <div className="col-sm-12 nopadding mob-banner">
				<div className="backbtn" onClick={me.backFn}><img src={'img/remedialMobile/icons/arrow.png'}></img></div>
                    <h1 className="otp-title">{this.rb("signup.otp.title")}</h1>
                </div>

                <div id="otpMobile" className="remedialLogin col-sm-12">

                    <div className="container">

                                <div className="row">
                                    <div className="col-md-12 mx-auto nopadding">
                                        <div className="rounded-0">
                                        
                                            <div className="">
                                            
                                                <FormWithConstraints ref={formWithConstraints => this.form = formWithConstraints}
                                                    onSubmit={this.handleSubmit} noValidate>
                                                   
                                                    {this.setPassword()}	
                                                    
                                                    <div className="server-messges">{me.state.serverMessage}</div>

                                                    <button data-ga={"Home - Users who have independently registered - Sign Up - New User - Start Learning"} disabled={this.state.submitButtonDisabled} className={"submitButton signup signupButton "+submitbtnAddCls}>{this.rb("signup.btn")}</button>
                                                    
                                                </FormWithConstraints>
                                            </div>
                                        </div>
                                    </div>


                                </div>

                            </div>
                        </div>
                    </div>
            )
        }
	}

	render() {
		if(this.state.loggedIn){
			return super.render();
		} else { 
			
			return (
			
		<div className="col-12 nomargin loginParent mobilesignup">

        {this.mobileUIOTP()}
        
		{this.getPasswordUI()}

		</div>
		);}
	}
}

export default MobileSignUp;



// WEBPACK FOOTER //
// ./src/views/login/MobileSignUp.js